if (!customElements.get('ahvte-navigation')) {
 customElements.define('ahvte-navigation', class extends HTMLElement {
  connectedCallback() {
   if (this.controller) return;
   this.controller = new AbortController();
   const on=(el,type,fn)=>el?.addEventListener(type,fn,{signal:this.controller.signal});
   const root=this.querySelector('[data-ahvte-header]'); if (!root) return;
   const mobile=root.querySelector('[data-ahvte-mobile-panel]'), toggle=root.querySelector('[data-ahvte-mobile-toggle]');
   const about=root.querySelector('[data-ahvte-about]'), aboutToggle=root.querySelector('[data-ahvte-about-toggle]'), aboutPanel=root.querySelector('[data-ahvte-about-panel]');
   const cats=[...root.querySelectorAll('[data-category]')];
   const desktop=()=>matchMedia('(min-width:1181px)').matches;
   const update=()=>{const scrolled=scrollY>Number(root.dataset.scrollThreshold||24);root.classList.toggle('is-fixed',root.dataset.sticky==='true'&&scrolled);root.classList.toggle('is-solid',root.dataset.overlay!=='true'||scrolled||root.classList.contains('has-open-menu')||about?.classList.contains('is-open')||cats.some(c=>c.classList.contains('is-open')));};
   const setAbout=open=>{about?.classList.toggle('is-open',open);aboutToggle?.setAttribute('aria-expanded',String(open));aboutPanel?.setAttribute('aria-hidden',String(!open));if(aboutPanel)aboutPanel.inert=!open;update();};
   const setCat=(cat,open)=>{const panel=cat.querySelector('[data-category-panel]');if(!panel)return;cat.classList.toggle('is-open',open);cat.querySelector('[data-category-toggle]').setAttribute('aria-expanded',String(open));panel.inert=!open;panel.setAttribute('aria-hidden',String(!open));update();};
   const closeCats=except=>cats.forEach(c=>{if(c!==except)setCat(c,false);});
   const openCat=cat=>{closeCats(cat);setAbout(false);setCat(cat,true);};
   this.closeCategories=()=>closeCats();
   const setMobile=open=>{root.classList.toggle('has-open-menu',open);toggle?.setAttribute('aria-expanded',String(open));const label=toggle?.querySelector('.ahvte-visually-hidden');if(label)label.textContent=open?'Close menu':'Open menu';if(mobile)mobile.inert=!open;if(open){this.oldOverflow=document.documentElement.style.overflow;document.documentElement.style.overflow='hidden';}else{document.documentElement.style.overflow=this.oldOverflow??'';closeCats();}update();};
   this.closeMobile=()=>{if(root.classList.contains('has-open-menu'))setMobile(false);};
   cats.forEach(cat=>{
    const button=cat.querySelector('[data-category-toggle]');
    on(button,'click',()=>{clearTimeout(this.hoverTimer);const open=!cat.classList.contains('is-open');closeCats(cat);setAbout(false);setCat(cat,open);});
    on(cat,'pointerenter',event=>{if(!desktop()||event.pointerType!=='mouse')return;clearTimeout(this.hoverTimer);this.hoverTimer=setTimeout(()=>openCat(cat),100);});
    on(cat,'pointerleave',event=>{if(!desktop()||event.pointerType!=='mouse')return;clearTimeout(this.hoverTimer);this.hoverTimer=setTimeout(()=>{if(!cat.contains(document.activeElement))setCat(cat,false);},160);});
    on(cat,'focusout',()=>queueMicrotask(()=>{if(desktop()&&!cat.contains(document.activeElement))setCat(cat,false);}));
    on(button,'keydown',event=>{if(event.key==='ArrowDown'){event.preventDefault();openCat(cat);cat.querySelector('[data-category-panel] a')?.focus();}});
   });
   on(toggle,'click',()=>{closeCats();setAbout(false);setMobile(!root.classList.contains('has-open-menu'));});
   on(root.querySelector('[data-ahvte-backdrop]'),'click',()=>setMobile(false));
   on(aboutToggle,'click',()=>{closeCats();setAbout(!about?.classList.contains('is-open'));});
   on(mobile,'click',event=>{if(event.target.closest('a'))setMobile(false);});
   on(document,'click',event=>{if(!event.target.closest('[data-category]'))closeCats();if(!about?.contains(event.target))setAbout(false);});
   on(document,'keydown',event=>{
    if(event.key==='Escape'){const cat=cats.find(c=>c.classList.contains('is-open'));if(cat){setCat(cat,false);cat.querySelector('[data-category-toggle]')?.focus();}else if(about?.classList.contains('is-open')){setAbout(false);aboutToggle?.focus();}else if(root.classList.contains('has-open-menu')){setMobile(false);toggle?.focus();}}
    if(event.key==='Tab'&&root.classList.contains('has-open-menu')){const nodes=[toggle,...mobile.querySelectorAll('a,button,input,select,summary')].filter(el=>el&&!el.closest('[inert]')&&el.getClientRects().length);const first=nodes[0],last=nodes[nodes.length-1];if(event.shiftKey&&document.activeElement===first){event.preventDefault();last?.focus();}else if(!event.shiftKey&&document.activeElement===last){event.preventDefault();first?.focus();}}
   });
   let wasDesktop=desktop();
   on(window,'resize',()=>{if(wasDesktop!==desktop()){closeCats();setAbout(false);this.closeMobile();wasDesktop=desktop();}update();});
   on(window,'scroll',update);
   on(document,'shopify:block:select',event=>{
    const id=event.detail?.blockId;const mode=desktop()?'desktop':'mobile';
    const cat=cats.find(c=>c.classList.contains('av-category--'+mode)&&(c.dataset.blockId===id||[...c.querySelectorAll('[data-card-id]')].some(card=>card.dataset.cardId===id)));
    if(cat){if(!desktop()&&!root.classList.contains('has-open-menu'))setMobile(true);openCat(cat);}
   });
   on(document,'shopify:section:unload',event=>{if(event.target.contains(this))this.disconnectedCallback();});
   root.classList.remove('has-open-menu');toggle?.setAttribute('aria-expanded','false');closeCats();if(mobile)mobile.inert=true;setAbout(false);update();
  }
  disconnectedCallback(){clearTimeout(this.hoverTimer);this.closeMobile?.();this.controller?.abort();this.controller=null;}
 });
}



if (!customElements.get('ahvte-search')) {
  customElements.define('ahvte-search', class extends HTMLElement {
    connectedCallback() {
      if (this.controller) return;

      this.controller = new AbortController();
      this.dialog = this.querySelector('dialog');
      this.panel = this.querySelector('.av-search__panel');
      this.input = this.querySelector('[data-search-input]');
      this.form = this.querySelector('[data-search-form]');
      this.results = this.querySelector('[data-search-results]');
      this.status = this.querySelector('[data-search-status]');
      this.clearButton = this.querySelector('[data-search-clear]');
      this.header = document.getElementById(this.dataset.headerId);
      this.triggers = [...(this.header?.querySelectorAll('[data-ahvte-search-open]') || [])];
      this.ratingCache = new Map();
      this.searchCounter = 0;

      const on = (el, type, fn) => el?.addEventListener(type, fn, { signal: this.controller.signal });

      this.triggers.forEach(trigger => on(trigger, 'click', event => {
        event.preventDefault();
        this.open(trigger);
      }));

      on(this.dialog, 'cancel', event => {
        event.preventDefault();
        this.close();
      });

      on(this.dialog, 'pointerdown', event => {
        this.outsideDown = event.target === this.dialog;
      });

      on(this.dialog, 'click', event => {
        if (event.target === this.dialog && this.outsideDown) this.close();
        if (event.target.closest('[data-search-close]')) this.close();

        const suggestion = event.target.closest('[data-search-suggestion]');
        if (suggestion) {
          event.preventDefault();
          const term = suggestion.dataset.searchSuggestion || suggestion.textContent.trim();
          this.input.value = term;
          this.clearButton.hidden = !term;
          this.input.focus();
          this.scheduleSearch(true);
        }
      });

      on(this.input, 'input', () => {
        this.clearButton.hidden = !this.input.value;
        this.dialog.classList.add('is-typing');
        this.results.classList.toggle('is-updating', this.dialog.classList.contains('has-search-content'));
        clearTimeout(this.typingTimer);
        this.typingTimer = setTimeout(() => this.dialog.classList.remove('is-typing'), 260);
        this.scheduleSearch();
      });

      on(this.clearButton, 'click', () => {
        this.input.value = '';
        this.clearButton.hidden = true;
        this.abortSearch();
        this.renderEmpty();
        this.input.focus();
      });

      on(this.form, 'submit', event => {
        const term = this.input.value.trim();
        if (!term) {
          event.preventDefault();
          this.input.focus();
          return;
        }
        // Submitting intentionally opens the full search page; typing itself never redirects.
      });

      on(window, 'pageshow', () => {
        if (this.dialog?.open) this.close(false);
      });

      this.renderEmpty();
    }

    disconnectedCallback() {
      clearTimeout(this.searchTimer);
      clearTimeout(this.typingTimer);
      clearTimeout(this.closeTimer);
      this.abortSearch();
      if (this.dialog?.open) {
        this.dialog.close();
        this.restoreScroll();
      }
      this.controller?.abort();
      this.controller = null;
    }

    get rootURL() {
      return this.dataset.root || window.Shopify?.routes?.root || '/';
    }

    get searchURL() {
      return this.dataset.searchUrl || `${this.rootURL}search`;
    }

    get suggestURL() {
      const base = this.dataset.suggestUrl || `${this.rootURL}search/suggest`;
      return base.endsWith('.json') ? base : `${base}.json`;
    }

    open(trigger) {
      clearTimeout(this.closeTimer);

      const nav = this.header?.closest('ahvte-navigation');
      nav?.closeCategories?.();
      nav?.closeMobile?.();

      const aboutToggle = this.header?.querySelector('[data-ahvte-about-toggle]');
      if (aboutToggle?.getAttribute('aria-expanded') === 'true') aboutToggle.click();

      const bag = document.querySelector('ahvte-bag');
      if (bag?.dialog?.open) bag.close?.();

      this.returnFocus = trigger || document.activeElement;

      if (!this.dialog.open) {
        this.oldOverflow = document.documentElement.style.overflow;
        document.documentElement.style.overflow = 'hidden';
        this.dialog.showModal();
        void this.dialog.offsetWidth;
      }

      this.dialog.classList.add('is-open');
      this.triggers.forEach(item => item.setAttribute('aria-expanded', 'true'));

      requestAnimationFrame(() => {
        this.input.focus({ preventScroll: true });
        if (this.input.value.trim().length >= 2) this.scheduleSearch(true);
      });
    }

    close(returnFocus = true) {
      if (!this.dialog?.open) return;

      this.dialog.classList.remove('is-open', 'is-typing', 'is-searching');
      this.results.classList.remove('is-updating');
      this.triggers.forEach(item => item.setAttribute('aria-expanded', 'false'));
      this.input.setAttribute('aria-expanded', 'false');
      this.abortSearch();

      clearTimeout(this.closeTimer);
      this.closeTimer = setTimeout(() => {
        if (this.dialog.open) this.dialog.close();
        this.restoreScroll();
        if (returnFocus && this.returnFocus?.isConnected) this.returnFocus.focus();
      }, matchMedia('(prefers-reduced-motion: reduce)').matches ? 0 : 320);
    }

    restoreScroll() {
      document.documentElement.style.overflow = this.oldOverflow ?? '';
    }

    abortSearch() {
      clearTimeout(this.searchTimer);
      this.searchRequest?.abort();
      this.searchRequest = null;
    }

    scheduleSearch(immediate = false) {
      clearTimeout(this.searchTimer);
      const term = this.input.value.trim();

      if (term.length < 2) {
        this.abortSearch();
        this.renderEmpty();
        this.status.textContent = term.length === 1 ? 'Type one more letter to search' : '';
        return;
      }

      this.searchTimer = setTimeout(() => this.search(term), immediate ? 0 : 130);
    }

    renderEmpty() {
      this.results.innerHTML = '';
      this.results.classList.remove('is-updating');
      this.dialog.classList.remove('has-search-content', 'is-searching');
      this.status.textContent = '';
      this.input.setAttribute('aria-expanded', 'false');
    }

    renderLoading() {
      this.dialog.classList.add('is-searching');
      if (!this.dialog.classList.contains('has-search-content')) {
        this.results.innerHTML = '';
      }
      this.status.textContent = 'Searching products';
      this.input.setAttribute('aria-expanded', 'true');
    }

    async search(term) {
      this.abortSearch();
      const currentSearch = ++this.searchCounter;
      this.searchRequest = new AbortController();
      this.renderLoading();

      const params = new URLSearchParams();
      params.set('q', term);
      params.set('resources[type]', 'query,product');
      params.set('resources[limit]', '6');
      params.set('resources[limit_scope]', 'each');
      params.set('resources[options][unavailable_products]', 'last');
      params.set('resources[options][fields]', 'title,product_type,variants.title,vendor,tag');

      try {
        const response = await fetch(`${this.suggestURL}?${params.toString()}`, {
          credentials: 'same-origin',
          headers: { Accept: 'application/json' },
          signal: this.searchRequest.signal
        });

        if (!response.ok) throw new Error(`Predictive search failed: ${response.status}`);

        const payload = await response.json();
        if (currentSearch !== this.searchCounter) return;

        const resources = payload?.resources?.results || {};
        const queries = Array.isArray(resources.queries) ? resources.queries.slice(0, 4) : [];
        const products = this.rankProducts(Array.isArray(resources.products) ? resources.products : [], term).slice(0, 6);

        this.renderResults(term, queries, products);
      } catch (error) {
        if (error.name === 'AbortError') return;
        console.warn('AHVTE predictive search could not load.', error);
        this.renderError(term);
      } finally {
        if (currentSearch === this.searchCounter) this.searchRequest = null;
      }
    }

    normalize(value) {
      return String(value || '')
        .toLowerCase()
        .normalize('NFKD')
        .replace(/[\u0300-\u036f]/g, '')
        .replace(/[^a-z0-9]+/g, ' ')
        .trim();
    }

    rankProducts(products, term) {
      const query = this.normalize(term);
      const tokens = query.split(/\s+/).filter(Boolean);

      return products
        .map((product, index) => {
          const title = this.normalize(product.title);
          const vendor = this.normalize(product.vendor);
          const type = this.normalize(product.type);
          const tags = (product.tags || []).map(tag => this.normalize(tag)).join(' ');
          let score = 0;

          if (title === query) score += 1200;
          if (title.startsWith(query)) score += 900;
          if (title.includes(query)) score += 760;
          if (vendor === query) score += 520;
          if (vendor && query.startsWith(vendor)) score += 260;

          tokens.forEach(token => {
            if (title.includes(token)) score += 90;
            if (vendor.includes(token)) score += 55;
            if (type.includes(token)) score += 35;
            if (tags.includes(token)) score += 24;
          });

          return { product, index, score };
        })
        .sort((a, b) => b.score - a.score || a.index - b.index)
        .map(item => item.product);
    }

    renderResults(term, queries, products) {
      const encodedTerm = encodeURIComponent(term);
      const viewAll = `${this.searchURL}?q=${encodedTerm}&options%5Bprefix%5D=last`;

      if (!queries.length && !products.length) {
        this.dialog.classList.remove('is-searching', 'is-typing');
        this.dialog.classList.add('has-search-content');
        this.results.classList.remove('is-updating');
        this.results.innerHTML = `
          <div class="av-search__no-results av-search__layout--enter">
            <h3>No close matches yet</h3>
            <p>Try a product type, brand, or a shorter version of your search.</p>
          </div>
        `;
        this.status.textContent = `No predictive results for ${term}`;
        this.input.setAttribute('aria-expanded', 'true');
        return;
      }

      const queryMarkup = queries.length ? `
        <aside>
          <p class="av-search__eyebrow">Suggested searches</p>
          <div class="av-search__suggestions">
            ${queries.map((query, index) => `
              <a
                class="av-search__suggestion"
                href="${this.safeURL(query.url || `${this.searchURL}?q=${encodeURIComponent(query.text || '')}`)}"
                data-search-suggestion="${this.escapeAttr(query.text || '')}"
                style="--av-i:${index}"
              >${this.escape(query.text || '')}</a>
            `).join('')}
          </div>
        </aside>
      ` : '<aside></aside>';

      const productMarkup = products.length ? `
        <section>
          <div class="av-search__products-head">
            <p class="av-search__eyebrow">Products</p>
            <a class="av-search__view-all" href="${this.safeURL(viewAll)}">View all results for “${this.escape(term)}”</a>
          </div>
          <div class="av-search__grid" role="listbox" aria-label="Product suggestions">
            ${products.map((product, index) => this.productCard(product, index + queries.length)).join('')}
          </div>
        </section>
      ` : `
        <section>
          <div class="av-search__products-head">
            <p class="av-search__eyebrow">Products</p>
            <a class="av-search__view-all" href="${this.safeURL(viewAll)}">View all results for “${this.escape(term)}”</a>
          </div>
          <div class="av-search__no-results">
            <p>No products matched yet. Try one of the suggested searches.</p>
          </div>
        </section>
      `;

      this.dialog.classList.remove('is-searching', 'is-typing');
      this.dialog.classList.add('has-search-content');
      this.results.classList.remove('is-updating');
      this.results.innerHTML = `<div class="av-search__layout av-search__layout--enter">${queryMarkup}${productMarkup}</div>`;
      this.status.textContent = `${products.length} product ${products.length === 1 ? 'match' : 'matches'} for ${term}`;
      this.input.setAttribute('aria-expanded', 'true');
      this.loadRatings();
    }

    productCard(product, index = 0) {
      const productURL = this.safeURL(product.url);
      const image = product.featured_image?.url || product.image || '';
      const imageURL = this.imageURL(image, 520);
      const imageAlt = this.escapeAttr(product.featured_image?.alt || product.title || '');
      const title = this.escape(product.title || 'Product');
      const price = this.productPrice(product);
      const available = product.available !== false;

      return `
        <article class="av-search__product" role="option" style="--av-i:${index}">
          <a class="av-search__product-link" href="${productURL}">
            <div class="av-search__image-wrap">
              ${imageURL
                ? `<img class="av-search__image" src="${imageURL}" alt="${imageAlt}" width="520" height="520" loading="eager">`
                : '<span class="av-search__no-image">Image unavailable</span>'}
            </div>
            <div class="av-search__product-copy">
              <h3 class="av-search__product-title">${title}</h3>
              <div class="av-search__rating is-loading" data-search-rating data-product-id="${this.escapeAttr(product.id)}" aria-label="Loading reviews" aria-busy="true">
                <span class="av-search__stars" style="--rating:0" aria-hidden="true"></span>
                <span data-rating-count>Loading</span>
              </div>
              <div class="av-search__meta">
                <span class="av-search__price">${price}</span>
                <span class="av-search__stock${available ? '' : ' is-sold-out'}">${available ? 'In stock' : 'Sold out'}</span>
              </div>
            </div>
          </a>
        </article>
      `;
    }

    productPrice(product) {
      const min = Number(product.price_min ?? product.price ?? 0);
      const max = Number(product.price_max ?? product.price ?? min);
      const formatted = this.money(min);
      return max > min ? `From ${formatted}` : formatted;
    }

    money(amount) {
      const currency = this.dataset.currency || 'USD';
      try {
        return new Intl.NumberFormat(document.documentElement.lang || 'en-US', {
          style: 'currency',
          currency,
          currencyDisplay: 'narrowSymbol'
        }).format(Number(amount) || 0);
      } catch {
        return `$${(Number(amount) || 0).toFixed(2)}`;
      }
    }

    async loadRatings() {
      const elements = [...this.querySelectorAll('[data-search-rating]')];

      await Promise.allSettled(elements.map(async element => {
        const productId = element.dataset.productId;
        if (!productId) {
          element.classList.add('is-unavailable');
          return;
        }

        try {
          const rating = await this.ratingFor(productId);
          if (!element.isConnected || element.dataset.productId !== productId) return;

          const stars = element.querySelector('.av-search__stars');
          const count = element.querySelector('[data-rating-count]');

          if (!rating || rating.count <= 0) {
            element.classList.add('is-unavailable');
            element.setAttribute('aria-busy', 'false');
            return;
          }

          stars?.style.setProperty('--rating', String(rating.average));
          if (count) count.textContent = `(${rating.count.toLocaleString()})`;
          element.classList.remove('is-loading');
          element.setAttribute('aria-busy', 'false');
          element.setAttribute('aria-label', `${rating.average.toFixed(1)} out of 5 stars from ${rating.count.toLocaleString()} reviews`);
        } catch {
          if (!element.isConnected) return;
          element.classList.remove('is-loading');
          element.classList.add('is-unavailable');
          element.setAttribute('aria-busy', 'false');
        }
      }));
    }

    ratingFor(productId) {
      if (this.ratingCache.has(productId)) return this.ratingCache.get(productId);

      const promise = (async () => {
        const shop = this.dataset.shop;
        if (!shop) return null;

        const params = new URLSearchParams({
          itemsPerPage: '1',
          shop,
          product_id: String(productId),
          default_sort_by: 'RECOMMENDED',
          last_updated_at: window.wiseReviewsLastUpdated || new Date().toISOString()
        });

        const response = await fetch(`https://wise-reviews.codexapps.co/api/proxy/reviews?${params.toString()}`, {
          headers: { Accept: 'application/json' }
        });

        if (!response.ok) throw new Error(`WiseReviews request failed: ${response.status}`);

        const data = await response.json();
        return {
          average: Math.max(0, Math.min(5, Number(data.average_rating) || 0)),
          count: Math.max(0, Number(data.meta?.total) || 0)
        };
      })();

      this.ratingCache.set(productId, promise);
      return promise;
    }

    renderError(term) {
      const href = this.safeURL(`${this.searchURL}?q=${encodeURIComponent(term)}&options%5Bprefix%5D=last`);
      this.dialog.classList.remove('is-searching', 'is-typing');
      this.dialog.classList.add('has-search-content');
      this.results.classList.remove('is-updating');
      this.results.innerHTML = `
        <div class="av-search__no-results">
          <h3>Search is temporarily unavailable</h3>
          <p><a class="av-search__view-all" href="${href}">Open full search results</a></p>
        </div>
      `;
      this.status.textContent = 'Predictive search is temporarily unavailable';
      this.input.setAttribute('aria-expanded', 'true');
    }

    imageURL(value, width = 520) {
      if (!value) return '';
      try {
        const url = new URL(value, location.origin);
        url.searchParams.set('width', String(width));
        return this.escapeAttr(url.href);
      } catch {
        return '';
      }
    }

    safeURL(value) {
      if (!value) return '';
      try {
        const url = new URL(value, location.origin);
        if (!['http:', 'https:'].includes(url.protocol)) return '';
        if (url.origin !== location.origin && !url.hostname.endsWith('.shopify.com') && !url.hostname.endsWith('.shopifycdn.com')) return '';
        return this.escapeAttr(url.href);
      } catch {
        return '';
      }
    }

    escape(value) {
      const node = document.createElement('span');
      node.textContent = String(value ?? '');
      return node.innerHTML;
    }

    escapeAttr(value) {
      return this.escape(value).replace(/"/g, '&quot;').replace(/'/g, '&#39;');
    }
  });
}



if (!customElements.get('ahvte-bag')) {
  customElements.define('ahvte-bag', class extends HTMLElement {
    connectedCallback() {
      if (this.controller) return;
      this.controller = new AbortController();
      this.dialog = this.querySelector('dialog');
      this.header = document.getElementById(this.dataset.headerId);
      this.trigger = this.header?.querySelector('[data-ahvte-bag-open]');
      this.destination = this.querySelector('[data-destination]');
      this.destination.value = this.dataset.country === 'US' ? 'US' : 'INT';
      try { this.localThresholds = JSON.parse(this.querySelector('[data-currency-thresholds]').textContent); } catch { this.localThresholds = {}; }
      const on = (el, name, fn) => el?.addEventListener(name, fn, {signal: this.controller.signal});
      on(this.trigger, 'click', (e) => { if (e.metaKey || e.ctrlKey || e.shiftKey || e.altKey) return; e.preventDefault(); e.stopPropagation(); this.open(); });
      on(this.dialog, 'cancel', (e) => { e.preventDefault(); this.close(); });
      on(this.dialog, 'click', (e) => {
        if (e.target === this.dialog && this.outsideDown) this.close();
        if (e.target.closest('[data-close]')) this.close();
        if (e.target.closest('[data-retry]')) this.refresh();
        const change = e.target.closest('[data-quantity]');
        if (change) this.change(change);
        if (this.busy && e.target.closest('[data-checkout]')) e.preventDefault();
      });
      on(this.dialog, 'pointerdown', (e) => { this.outsideDown = e.target === this.dialog; });
      on(this.destination, 'change', () => { if (this.cart) this.shipping(); });
      on(document, 'ahvte:cart-updated', () => { if (this.dialog.open) this.refresh(); });
      on(window, 'pageshow', () => { if (this.dialog.open) this.refresh(); });
      this.connectThemeCart();
      // Optional integration for other custom add-to-cart scripts:
      // document.dispatchEvent(new CustomEvent('ahvte:cart-updated'));
      // document.querySelector('ahvte-bag').open();
    }
    disconnectedCallback() {
      clearTimeout(this.closeTimer);
      if (this.dialog?.open) { this.dialog.close(); this.restoreScroll(); }
      this.controller?.abort(); this.controller = null;
      this.legacyObserver?.disconnect();
      (this.legacyBridges || []).forEach(({prototype, original, redirected}) => {
        if (prototype.open === redirected) prototype.open = original;
      });
      this.legacyBridges = [];
      this.pendingRefresh = false;
    }
    connectThemeCart() {
      // Refresh/Dawn product forms call renderContents(), which then calls open().
      // Redirect only that presentation step; never submit an extra add request.
      this.legacyBridges = [];
      const lifecycle = this.controller.signal;
      const bag = this;
      for (const tag of ['cart-drawer', 'cart-notification']) {
        const install = () => {
          if (lifecycle.aborted || !bag.isConnected) return;
          const prototype = customElements.get(tag)?.prototype;
          if (!prototype || typeof prototype.open !== 'function') return;
          if (bag.legacyBridges.some(bridge => bridge.prototype === prototype)) return;
          const original = prototype.open;
          const redirected = function (...args) {
            if (lifecycle.aborted || !bag.isConnected) return original.apply(this, args);
            bag.dismissThemeCart(this);
            return bag.open();
          };
          prototype.open = redirected;
          bag.legacyBridges.push({prototype, original, redirected});
        };
        if (customElements.get(tag)) install();
        else customElements.whenDefined(tag).then(install);
      }
      // Also support collection scripts that directly toggle the old drawer's
      // active class instead of calling its open() method. No request interception.
      this.legacyObserver = new MutationObserver(records => {
        if (lifecycle.aborted || !bag.isConnected) return;
        const legacy = new Set();
        records.forEach(record => {
          const target = record.target;
          if (target.matches?.('cart-drawer.active, cart-notification.active')) legacy.add(target);
          if (target.matches?.('#cart-notification.active')) {
            const owner = target.closest('cart-notification');
            if (owner) legacy.add(owner);
          }
          record.addedNodes?.forEach(node => {
            if (node.matches?.('cart-drawer.active, cart-notification.active')) legacy.add(node);
          });
        });
        if (!legacy.size) return;
        legacy.forEach(node => bag.dismissThemeCart(node));
        void bag.open();
      });
      this.legacyObserver.observe(document.body, {subtree: true, childList: true, attributes: true, attributeFilter: ['class']});
    }
    dismissThemeCart(legacy) {
      const panel = legacy.querySelector?.('#cart-notification');
      if (legacy.classList.contains('active') || panel?.classList.contains('active')) {
        if (typeof legacy.close === 'function') legacy.close();
        legacy.classList.remove('active');
        panel?.classList.remove('active');
        document.body.classList.remove('overflow-hidden');
      }
    }
    finishRequest() {
      this.busyState(false);
      if (this.pendingRefresh && this.isConnected) {
        this.pendingRefresh = false;
        queueMicrotask(() => { if (this.isConnected) void this.refresh(); });
      }
    }
    get rootURL() { return this.dataset.root || '/'; }
    q(selector) { return this.querySelector(selector); }
    async open() {
      clearTimeout(this.closeTimer);
      if (!this.dialog.open) {
        this.header?.closest('ahvte-navigation')?.closeCategories?.();
        if (this.header?.classList.contains('has-open-menu')) this.header.querySelector('[data-ahvte-mobile-toggle]')?.click();
        if (this.header?.querySelector('[data-ahvte-about-toggle]')?.getAttribute('aria-expanded') === 'true') this.header.querySelector('[data-ahvte-about-toggle]').click();
        this.returnFocus = document.activeElement;
        this.oldOverflow = document.documentElement.style.overflow;
        document.documentElement.style.overflow = 'hidden';
        this.dialog.showModal();
        this.trigger?.setAttribute('aria-expanded', 'true');
        void this.dialog.offsetWidth;
      }
      this.dialog.classList.add('is-open');
      await this.refresh();
    }
    restoreScroll() { document.documentElement.style.overflow = this.oldOverflow ?? ''; }
    close() {
      this.dialog.classList.remove('is-open');
      this.trigger?.setAttribute('aria-expanded', 'false');
      clearTimeout(this.closeTimer);
      this.closeTimer = setTimeout(() => {
        this.dialog.close(); this.restoreScroll();
        if (this.returnFocus?.isConnected) this.returnFocus.focus();
      }, matchMedia('(prefers-reduced-motion: reduce)').matches ? 0 : 420);
    }
    async request(path, options = {}) {
      const response = await fetch(this.rootURL + path, {credentials: 'same-origin', cache: 'no-store', ...options});
      const data = await response.json();
      if (!response.ok) throw new Error(typeof data.description === 'string' ? data.description : 'Your cart could not be updated. Please try again.');
      return data;
    }
    busyState(value) {
      this.busy = value; this.q('[data-items]').setAttribute('aria-busy', String(value));
      this.querySelectorAll('[data-quantity], [data-retry]').forEach(b => b.disabled = value);
      this.q('[data-checkout]').setAttribute('aria-disabled', String(value));
    }
    error(message) { this.q('[data-error]').textContent = message; this.q('[data-error]').hidden = !message; this.q('[data-retry]').hidden = !message; this.q('[data-fallback]').hidden = !message; }
    async refresh() {
      if (this.busy) { this.pendingRefresh = true; return; }
      this.busyState(true); this.error('');
      try { this.render(await this.request('cart.js')); }
      catch { this.error('We couldn’t load your cart. Please try again or open the full cart below.'); this.q('[data-shipping-message]').textContent = 'Shipping estimate unavailable.'; this.q('[data-progress]').hidden = true; }
      finally { this.finishRequest(); }
    }
    async change(button) {
      if (this.busy) return;
      const index = Number(button.dataset.index), action = button.dataset.action;
      this.busyState(true); this.error('');
      try {
        this.render(await this.request('cart/change.js', {method: 'POST', headers: {'Content-Type': 'application/json'}, body: JSON.stringify({id: button.dataset.key, quantity: Number(button.dataset.quantity)})}));
        const next = this.querySelector(`[data-index="${Math.min(index, this.cart.items.length - 1)}"][data-action="${action}"]`);
        this.busyState(false);
        (next || this.q('[data-close]')).focus();
        document.dispatchEvent(new CustomEvent('ahvte:bag-changed', {detail: {cart: this.cart}}));
      } catch (error) {
        // A failed response can follow a server-side adjustment: reconcile before retrying.
        try { this.render(await this.request('cart.js')); } catch {}
        this.error(error.message);
        this.q('[data-close]').focus();
      } finally { this.finishRequest(); }
    }
    money(cents) { return new Intl.NumberFormat(document.documentElement.lang || 'en-US', {style: 'currency', currency: this.cart.currency, currencyDisplay: 'code'}).format(cents / 100); }
    escape(value) { const node = document.createElement('span'); node.textContent = String(value ?? ''); return node.innerHTML.replace(/"/g, '&quot;').replace(/'/g, '&#39;'); }
    safeURL(value) { try { const url = new URL(value, location.origin); return ['https:', 'http:'].includes(url.protocol) ? this.escape(url.href) : ''; } catch { return ''; } }
    shipping() {
      const region = this.destination.value;
      const usd = region === 'US' ? 49 : 69;
      const threshold = this.cart.currency === 'USD' ? usd : Number(this.localThresholds[this.cart.currency]?.[region]);
      const valid = Number.isFinite(threshold) && threshold > 0;
      this.q('[data-progress]').hidden = !valid;
      if (!valid) { this.q('[data-shipping-message]').textContent = `Free shipping from $${usd} USD. Eligibility is confirmed at checkout in your selected currency.`; return; }

      const remaining = Math.max(0, threshold * 100 - this.cart.total_price);
      const percent = Math.min(100, Math.round(this.cart.total_price / (threshold * 100) * 100));
      this.q('[data-shipping-message]').textContent = remaining ? `${this.money(remaining)} away from free shipping.` : 'Your cart qualifies for free shipping at the selected destination.';
      this.q('[data-fill]').style.width = percent + '%';
      this.q('[data-progress]').setAttribute('aria-valuenow', percent);
    }
    render(cart) {
      this.cart = cart;
      this.q('[data-count]').textContent = `(${cart.item_count})`;
      this.q('[data-empty]').hidden = cart.item_count > 0;
      this.q('[data-footer]').hidden = cart.item_count === 0;
      this.q('[data-total]').textContent = this.money(cart.total_price);
      this.q('[data-items]').innerHTML = cart.items.map((item, index) => {
        const key = this.escape(item.key), name = this.escape(item.product_title || item.title);
        // data-quantity serves as both the selector and numeric payload.
        const button = (action, value, label, text, cls='') => `<button type="button" class="${cls}" data-index="${index}" data-action="${action}" data-key="${key}" data-quantity="${value}" aria-label="${label} ${name}">${text}</button>`;
        return `<li class="av-bag__item">${item.image ? `<a href="${this.safeURL(item.url)}"><img class="av-bag__image" src="${this.safeURL(item.image)}" alt="${name}" width="108" height="122"></a>` : '<div></div>'}<div><a class="av-bag__name" href="${this.safeURL(item.url)}">${name}</a>${item.variant_title && item.variant_title !== 'Default Title' ? `<p class="av-bag__detail">${this.escape(item.variant_title)}</p>` : ''}${item.selling_plan_allocation ? `<p class="av-bag__detail">${this.escape(item.selling_plan_allocation.selling_plan.name)}</p>` : ''}<div class="av-bag__row"><div class="av-bag__quantity">${button('minus',item.quantity-1,'Decrease quantity of','−')}<span>${item.quantity}</span>${button('plus',item.quantity+1,'Increase quantity of','+')}</div><span class="av-bag__price">${item.original_line_price > item.final_line_price ? `<s>${this.money(item.original_line_price)}</s>` : ''}${this.money(item.final_line_price)}</span></div>${button('remove',0,'Remove','Remove','av-bag__remove')}</div></li>`;
      }).join('');
      if (this.trigger) {
        this.trigger.setAttribute('aria-label', `Cart, ${cart.item_count} items`);
        let count = this.trigger.querySelector('.ahvte-header__cart-count');
        if (!count) { count = document.createElement('span'); count.className = 'ahvte-header__cart-count'; count.setAttribute('aria-hidden','true'); this.trigger.append(count); }
        count.textContent = cart.item_count; count.hidden = !cart.item_count;
      }
      this.shipping();
      this.q('[data-status]').textContent = `${cart.item_count} items in your cart. Total ${this.money(cart.total_price)}.`;
    }
  });
}
